module.exports = "<app-bending-machine-list></app-bending-machine-list>\n"